<template>
  <!--预定记录公用弹窗-->
    <el-dialog :visible.sync="visible" :before-close="resetForm" width="900px" v-loading="loading"
               :close-on-click-modal="false">
      <div slot="title">
        <z-title :title="(id?'编辑':'新增')+'预定'"></z-title>
      </div>
      <el-form :model="dataForm" :rules="rules" size="medium" ref="ruleForm" class="rulefrom" label-width="100px">
        <div class="flex-n">
          <el-form-item label="客户姓名" prop="customName" :show-message="false" :inline-message="true">
            <el-input maxlength="20" class="w-220" v-model="dataForm.customName"
                      placeholder="请输入用户姓名"></el-input>
          </el-form-item>
          <el-form-item label="预定状态" prop="orderState" :show-message="false">
            <div class="flex-n fac">
              <order-state v-model="dataForm.orderState" placeholder="请选择预定状态"
                           class="w-220"></order-state>
              <el-popconfirm
                title="是否取消该预定单？"
                @onConfirm="cancelOrder"
                v-if="id&&dataForm.auth&&dataForm.auth.isDelete=='1'"
              >
                <el-button  slot="reference" class="ml-10" size="medium" type="primary"
                >取消预定
                </el-button>
              </el-popconfirm>
            </div>
          </el-form-item>
        </div>
        <div class="flex-n">
          <el-form-item label="手机号码" prop="phone">
            <el-input type="number" class="w-220" maxlength="11" v-model="dataForm.phone"
                      placeholder="请输入用户手机号"></el-input>

          </el-form-item>
          <el-form-item label="预定人员" prop="createUserName" :inline-message="true">
            <el-input class="w-220" v-model="dataForm.createUserName"
                      disabled></el-input>
          </el-form-item>
        </div>
        <div class="flex-n">
          <el-form-item label="预定日期" prop="orderDate" :show-message="false">
            <el-date-picker
              v-model="dataForm.orderDate"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="请选择预定日期"
              @change="changeOrderDate"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="已收定金" :rules="dataForm.orderState=='02'?rules.downPayment:[]"
                        :show-message="false"
                        prop="downPayment">
            <div class="flex-n fac">
              <el-input placeholder="￥" class="w-200 mr-10" v-model="dataForm.downPayment"
                        v-number="{precision:2}">
              </el-input>
              <div>元</div>
            </div>
          </el-form-item>
        </div>
        <div class="flex-n fac">
          <el-form-item label="预定场地" prop="houseId" :show-message="false">
            <want-house clearable v-model="dataForm.houseId" placeholder="请选择预定场地"
                        class="w-220" @change="changeHouseInfo"></want-house>
          </el-form-item>
          <!--厅才有预定类型-->
          <el-form-item label="预定类型" v-if="dataForm.houseTypeCode=='01'"
                        prop="orderTypeId" :show-message="false">
            <order-type v-model="dataForm.orderTypeId" placeholder="请选择预定类型" class="w-220"></order-type>
          </el-form-item>
        </div>
        <div class="flex-n" v-if="dataForm.houseId&&dataForm.orderDate">
          <el-form-item label="时间段" prop="activityBeginTime">
            <el-select class="w-120" v-model="dataForm.activityBeginTime" filterable clearable placeholder="开始时间"
                       @change="changeBeginTime">
              <el-option
                v-for="(itm,idx) in timeSelectList"
                :key="idx"

                :label="itm.label"
                :value="itm.value">
              </el-option>
            </el-select>
          </el-form-item>
          <div class="plr-10">-</div>
          <el-form-item label="" prop="activityEndTime" label-width="0">
            <el-select class="w-120 mr-10" v-model="dataForm.activityEndTime" filterable clearable placeholder="开始时间"
                       @change="validatorBeginTime">
              <el-option
                v-for="(itm,idx) in timeSelectList"
                :key="idx"
                :disabled="Number(itm.value.replace(':',''))<=Number(dataForm.activityBeginTime.replace(':',''))"
                :label="itm.label"
                :value="itm.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-button type="primary" round class="ele-btn-small" style="margin-top: 4px"
                     v-for="(item,index) in timeList" :title="item.beginTime+'~'+item.endTime"
                     @click="chooseTime(item.beginTime,item.endTime)">
            {{ item.tagName }}
          </el-button>
        </div>
        <!--</el-form-item>-->
        <div class="haschoosetime flex-w fac mb-10" v-if="selectableRange&&selectableRange.length>0">
          <i class="el-icon-warning ml-10"></i>
          <div class="ml-10">已被预定时间段(不可选)：</div>
          <el-tag :type="(new Date(dataForm.orderDate + ' ' + dataForm.activityBeginTime).getTime() >= new Date(dataForm.orderDate + ' ' + item.activityBeginTime).getTime()
                &&new Date(dataForm.orderDate + ' ' + dataForm.activityBeginTime).getTime() < new Date(dataForm.orderDate + ' ' + item.activityEndTime).getTime()
                ||new Date(dataForm.orderDate + ' ' + dataForm.activityEndTime).getTime() >new Date(dataForm.orderDate + ' ' + item.activityBeginTime).getTime()
                &&new Date(dataForm.orderDate + ' ' + dataForm.activityEndTime).getTime() <= new Date(dataForm.orderDate + ' ' + item.activityEndTime).getTime()) ?'danger':'info'"
                  size="mini" class="mr-10" v-for="item,index in selectableRange">
            {{ item.activityBeginTime }}~{{ item.activityEndTime }}
          </el-tag>
        </div>
        <template v-if="dataForm.houseTypeCode&&dataForm.houseTypeCode!='03'">
          <el-form-item label="收费方式"
                        prop="mainPayType"
                        :inline-message="true">
            <el-radio-group v-model="dataForm.mainPayType" @change="paywayChange">
              <el-radio-button v-for="item,index in paywayList" :label="item.dicCode">{{ item.dicName }}
              </el-radio-button>
            </el-radio-group>
          </el-form-item>

          <div v-if="dataForm.mainPayType=='03'">
            <el-form-item label="包场价格">
              <el-input placeholder="￥" class="w-120  mr-10" v-model="orderall"
                        v-number="{precision:2}">
              </el-input>
              <el-button type="primary" class="ele-btn-medium" v-if="!addtables" @click="addtables=true">
                +桌
              </el-button>
              <el-button type="primary" class="ele-btn-medium" v-if="!addpeople" @click="addpeople=true">
                +人
              </el-button>
            </el-form-item>
          </div>
          <!--按人数-->
          <div v-if="dataForm.mainPayType=='01'||addpeople" class="flex-n fac">
            <el-form-item label="每人价格">
              <el-input placeholder="￥" class="w-120" v-model="onePrice1"
                        v-number="{precision:2,max:100000}">
              </el-input>
            </el-form-item>
            <el-form-item label="✖" label-width="50px"></el-form-item>
            <el-form-item label="预定人数" label-width="80px">
              <el-input placeholder="" class="w-120" v-model="orderPeople1"
                        v-number="{precision:1,step:0.5,max:1000}">
              </el-input>
            </el-form-item>
            <el-form-item label="=" label-width="30px" class="textnowrap mr-10">
              <div>{{ ((onePrice1 || 0) * (orderPeople1 || 0)).toFixed(2) }}</div>
            </el-form-item>
            <el-form-item label-width="0" v-if="addpeople">
              <el-button type="primary" class="ele-btn-medium btn1" @click="addpeople=false"><i
                class="el-icon-minus"></i></el-button>
            </el-form-item>
          </div>
          <!--按桌数-->
          <div v-if="dataForm.mainPayType=='02'||addtables" class="flex-n fac">
            <el-form-item label="每桌价格">
              <el-input placeholder="￥" class="w-120" v-model="onePrice2"
                        v-number="{precision:2,max:100000}">
              </el-input>
            </el-form-item>
            <el-form-item label="✖" label-width="50px"></el-form-item>
            <el-form-item label="预定桌数" label-width="80px">
              <el-input placeholder="" class="w-120" v-model="orderPeople2"
                        v-number="{precision:1,step:0.5,max:1000}">
              </el-input>
            </el-form-item>
            <el-form-item label="=" label-width="30px" class="mr-10 textnowrap">
              <div>{{ ((onePrice2 || 0) * (orderPeople2 || 0)).toFixed(2) }}</div>
            </el-form-item>
            <el-form-item label="备用桌数" label-width="80px" class="mr-10">
              <el-input class="w-120" v-model="bdesks"
                        v-number="{max:1000}">
              </el-input>
            </el-form-item>
            <el-form-item label-width="0" v-if="addtables">
              <el-button type="primary" class="ele-btn-medium btn1" @click="addtables=false"><i
                class="el-icon-minus"></i></el-button>
            </el-form-item>
          </div>

        </template>
        <div class="flex-n">
          <template v-if="dataForm.houseTypeCode&&dataForm.houseTypeCode!='03'">
            <el-form-item label="预定套餐" prop="packageId" :show-message="false"
            >
              <package-order v-model="dataForm.packageId" placeholder="请选择预定套餐"
                             clearable class="w-180 mr-10" @change="changePackage"></package-order>
              <el-button type="primary" class="ele-btn-medium" :disabled="!dataForm.packageId"
                         @click="fixedSetmeal">修改套餐

              </el-button>
            </el-form-item>
          </template>
          <el-form-item label="增加项目" prop="extraRealMoney">
            <el-input-number placeholder="￥" disabled v-model="dataForm.extraRealMoney" :controls="false"
                             :precision="2"
                             :step="0.1" class="w-180 mr-10"
                             :min="0" :max="9999999999"></el-input-number>

            <el-button type="primary" class="ele-btn-medium" @click="editLook">编辑查看</el-button>
          </el-form-item>
        </div>
        <div class="flex-n" v-if="dataForm.packageId">
          <el-form-item label="开餐时间" prop="eatTime">
            <!--            <el-time-select-->
            <!--                value-format="HH:mm" format="HH:mm"-->
            <!--                class="w-220"-->
            <!--                placeholder="起始时间"-->
            <!--                v-model="dataForm.eatTime"-->
            <!--                :inline-message="true"-->
            <!--                :picker-options="{ start: dataForm.activityBeginTime||'00:00',-->
            <!--                step: '00:10',-->
            <!--                end: dataForm.activityEndTime||'24:00',-->
            <!--                }">-->
            <!--            </el-time-select>-->

            <el-select class="w-220" filterable v-model="dataForm.eatTime" clearable placeholder="起始时间">
              <el-option
                v-for="(itm,idx) in timeSelectList"
                :key="idx"
                :disabled="Number(itm.value.replace(':',''))<=Number(dataForm.activityBeginTime.replace(':',''))"
                :label="itm.label"
                :value="itm.value">
              </el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="flex-n">
          <el-form-item label="顾客来源" prop="customFromId"
                        :rules="dataForm.orderState=='02'?rules.customFromId:[]"
                        :show-message="false">
            <user-from v-model="dataForm.customFromId" placeholder="请选择来源" class="w-220"></user-from>
          </el-form-item>
          <el-form-item label="总计应收" prop="totalMoney">
            <div class="flex-n fac">
              <el-input-number disabled class="w-200 mr-10" placeholder="￥" :value="totalMoney"
                               :controls="false"
                               :min="0" :precision="2" :step="0.1" :max="9999999999"></el-input-number>
              <div>元</div>
            </div>
          </el-form-item>
        </div>

        <template v-if="dataForm.houseTypeCode!='03'">
          <div class="flex-n">
            <el-form-item label="是否提醒">
              <el-radio-group v-model="checkedAlert" class="w-220"
                              :disabled="new Date(dataForm.orderDate).getTime() < new Date($TM.getDayArea().date).getTime()">
                <el-radio :label="false">否</el-radio>
                <el-radio :label="true">是</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item v-if="checkedAlert" label="提醒日期" prop="alertDate">
              <el-date-picker
                :picker-options="pickerOptions"
                v-model="dataForm.alertDate"
                value-format="yyyy-MM-dd"
                type="date"
                :disabled="new Date(dataForm.orderDate).getTime() < new Date($TM.getDayArea().date).getTime()"
                placeholder="请选择提醒日期">
              </el-date-picker>
            </el-form-item>
          </div>
        </template>


        <div class="flex-n">

          <el-form-item label="预定时间" v-if="id" prop="createTime" :inline-message="true">
            <el-input class="w-220" v-model="dataForm.createTime" disabled></el-input>
          </el-form-item>
        </div>
        <el-form-item label="备 注" prop="remark" :show-message="false"
                      :rules="dataForm.orderState=='03'?[{required: true, trigger: 'change'}]:[]">
          <el-input type="textarea" rows="6" show-word-limit v-model="dataForm.remark" resize="none"
                    maxlength="512"></el-input>
        </el-form-item>
        <el-form-item class="mt-10 flex-n fje">
          <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
          <el-button @click="resetForm">取 消</el-button>
        </el-form-item>
      </el-form>
      <!--修改套餐-->
      <extra-list title="修改套餐" havepackage v-if="dataForm.packageId" :packageName="dataForm.packageName"
                  :packageId="dataForm.packageId"
                  v-model="setmealArea" ref="setmeal"
                  :visible.sync="showsetmeal" @getTotal="getTotal"></extra-list>
      <!--额外合计项目-->
      <extra-list title="额外合计项目" v-model="extraArea" ref="extra" :visible.sync="showextra"
                  @getTotal="getTotal"></extra-list>
    </el-dialog>

</template>

<script>
  import ZTitle from "../../components/ZTitle";
  import UserFrom from "../../components/data/userFrom";

  import WantHouse from "../../components/data/wantHouse";
  import OrderType from "../../components/data/orderType";
  import OrderState from "../../components/data/orderState";
  import ExtraList from "./extra";
  import PackageOrder from "../../components/data/packageOrder";
  import ElButton from "element-ui/packages/button/src/button";


  export default {
    components: {
      ElButton,
      PackageOrder,
      ExtraList,
      OrderState,
      OrderType,
      WantHouse,
      UserFrom,
      ZTitle
    },
    name: "books",
    props: {
      visible: Boolean,
      data: Object,
      id: String,
      askid: String,
      setmeal: Object,//套餐
    },


    data() {
      let checkpackages = (rule, value, callback) => {
        // console.log(value)
        if (value == '') {
          return callback(new Error(' '));
        }
        return callback();
      };
      let validatetel = (rule, value, callback) => {
        // if (this.dataForm.orderState == '02') {
        if (value && value != '' && value.length != 11) {
          return callback(new Error('请输入11位的有效手机号码'));
        }
        // }

        return callback();
      };
      let checkactivityTime = (rule, value, callback) => {
        let activityEndTime = this.dataForm.activityEndTime;
        let today = this.$TM.getDayArea().date;
        if (this.dataForm.activityBeginTime && this.dataForm.activityEndTime) {
          var begin = Number(this.dataForm.activityBeginTime.replace(':', '')) || '',
            end = Number(this.dataForm.activityEndTime.replace(':', '')) || '',
            range = this.selectableRange,
            rangebegin = 0, rangeend = 0;

          for (let i in range) {
            rangebegin = Number(range[i].activityBeginTime.replace(':', '')) || '';
            rangeend = Number(range[i].activityEndTime.replace(':', '')) || ''
            console.log(rangebegin, rangeend, begin, end, range)
            if ((begin >= rangebegin && begin < rangeend) || (end > rangebegin && end <= rangeend) || (begin < rangebegin && end > rangeend)) {
              return callback(new Error('该时间段已被预定'))
            }
          }
        }
        if (!value || !activityEndTime) {
          return callback(new Error('请输入完整时间段'))
        }
        return callback();
      };
      let checkactivityTime2 = (rule, value, callback) => {
        if (!value) {
          return callback(new Error(' '))
        }
        return callback();
      };
      let validatealertdate = (rule, value, callback) => {
        if (value == null) {
          return callback(new Error(' '));
        }
        return callback();
      };
      return {
        checkedAlert: false,//是否提醒
        orderAlertDaysBefore: 0,//预定提醒提前几天默认
        loading: false,
        downPayment: 0,
        startTime: '',
        endTime: '',
        selectableRange: [],
        paywayList: [],//支付方式
        //已存在时间段
        timeList: [],
        addtables: false,
        addpeople: false,
        //付款方式参数 选中必填
        onePrice1: undefined,
        orderPeople1: undefined,
        onePrice2: undefined,
        orderPeople2: undefined,
        bdesks: undefined,
        orderall: undefined,
        showsetmeal: false,//显示套餐弹窗
        showextra: false,
        edittitle: '额外合计项目',
        //套餐
        setmealArea: {},
        //额外项目
        extraArea: {},
        dataForm: {
          askId: '',
          customName: '',//客户姓名
          phone: '',//手机号码
          orderDate: '',//预定日期
          activityBeginTime: '',//时间段
          activityEndTime: '',
          houseId: '',//预定场地
          houseTypeCode: null,
          orderTypeId: '',//预定类型 ?orderTypeId
          //收费方式
          mainPayTypeText: '',
          mainPayType: '01',
          payTypes: [],
          packageId: null,
          packageName: null,

          orderPackage: {},

          //增加项目
          orderExtra: {},
          extraRealMoney: 0,
          packageRealMoney: '',//套餐实收款
          packageNeedMoney: '',//套餐应收款
          orderMoney: '',//订单金额（总计应收款）
          downPayment: 0,//已收定金
          alertDate: null,//提醒日期
          //总计应收
          orderState: '02',//预定状态
          customFromId: '',//顾客来源
          remark: '',//备注
          eatTime: ''

        },
        rules: {
          customName: [{required: true, trigger: 'blur'}],
          phone: [{validator: validatetel, trigger: 'change'}],

          orderDate: [{required: true, trigger: 'change'}],
          alertDate: [{required: true, validator: validatealertdate, trigger: 'change'}],
          activityBeginTime: [{
            required: true,
            message: '请输入完整时间段',
            trigger: 'change'
          }, {required: true, validator: checkactivityTime, trigger: 'change'}],
          activityEndTime: [{required: true, validator: checkactivityTime2, trigger: 'change'}],
          houseId: [{required: true, trigger: 'change'}],
          orderTypeId: [{required: true, trigger: 'change'}],
          packageId: [{validator: checkpackages, trigger: 'change'}],
          // orderMoney: [{required: true, message: '请输入实际应收', trigger: 'change'}],
          orderState: [{required: true, trigger: 'change'}],
          customFromId: [{required: true, trigger: 'change'}],
          downPayment: [{required: true, message: '请输入已收定金', trigger: 'blur'}],
          eatTime: [{required: true, message: '请选择开餐时间', trigger: 'blur'}]
        },
        beginTime: '00:00',
        timeSelectList: [],
        beginTime2: '00:00',
        finishTime: '24:00',
        timeEndList: []
      }
    },
    watch: {
      visible(newval, oldval) {
        if (newval) {
          if (this.id) {
            this.getData();
          }
          this.getBaseInfo();
          this.getPayType();
        }
      }
    },
    computed: {
      totalMoney(newval, oldval) {
        var mainPayType = this.dataForm.mainPayType;

        var value = 0;
        if (mainPayType == '01') {
          value = Number(this.onePrice1) * Number(this.orderPeople1)
        }
        if (mainPayType == '02') {
          value = Number(this.onePrice2) * Number(this.orderPeople2)
        }
        if (mainPayType == '03') {
          value = (this.addtables ? Number(this.onePrice2) * Number(this.orderPeople2) : 0) + (this.addpeople ? Number(this.onePrice1) * Number(this.orderPeople1) : 0) + Number(this.orderall);
        }
        this.dataForm.packageNeedMoney = value;
        value += Number(this.dataForm.extraRealMoney);
        this.dataForm.orderMoney = value;
        return value
      },
      pickerOptions() {
        return {
          //提醒日期不是空  大于当天 小于提醒
          disabledDate: time => (this.dataForm.orderDate == null ? '' : (time.getTime() > new Date(this.dataForm.orderDate).getTime() || (time.getTime() < Date.now() - 24 * 60 * 60 * 1000)))
        }
      },
    },
    methods: {
      getData() {
        this.$axios.get('/order/orderDetailById/' + this.id).then(res => {
          console.log('根据id查询订单的信息', res)
          this.dataForm = res.data;
          let data = res.data;
          for (var i in data.payTypes) {
            if (data.payTypes[i].payTypeCode == '01') {
              if (data.mainPayType == '03')
                this.addpeople = true;
              this.onePrice1 = data.payTypes[i].onePrice;
              this.orderPeople1 = data.payTypes[i].orderCount;
            }
            if (data.payTypes[i].payTypeCode == '02') {
              if (data.mainPayType == '03')
                this.addtables = true;
              this.onePrice2 = data.payTypes[i].onePrice;
              this.orderPeople2 = data.payTypes[i].orderCount;
              this.bdesks = data.payTypes[i].bakOrderCount;
            }
            if (data.payTypes[i].payTypeCode == '03') {
              this.orderall = data.payTypes[i].housePrice;
            }
          }
          this.startTime = data.activityBeginTime;
          this.endTime = data.activityEndTime;
          this.setmealArea = {
            itemsFoodTree: data.orderPackage.itemsFoods,
            itemsExTree: data.orderPackage.itemsExs
          }
          this.extraArea = {
            itemsFoodTree: data.orderExtra.itemsFoods,
            itemsExTree: data.orderExtra.itemsExs
          };
          if (data.alertDate) {
            this.checkedAlert = true;
          }
        }).catch(err => {
          this.$message.error(err.msg);
        })
      },
      //预定提醒提前几天默认
      getBaseInfo() {
        this.$axios.get('/config/baseByStoreId/' + this.$root.getStorage('storeId')).then(res => {
          console.log('基本店铺设置信息', res.data)
          //默认定金
          this.$set(this.dataForm, 'downPayment', res.data.orderDefaultMoney);
          //默认几天前提醒
          this.orderAlertDaysBefore = Number(res.data.orderAlertDaysBefore || 0);
          this.downPayment = res.data.orderDefaultMoney;
          let timeRange = res.data.timeRange.split('-')
          this.beginTime = (Number(timeRange[0]) > 9 ? timeRange[0] : ('0' + timeRange[0])) || '00:00';
          this.finishTime = (Number(timeRange[1]) > 9 ? timeRange[1] : ('0' + timeRange[1])) || '24:00';
          this.timeSelectList = this.getTimeList(this.beginTime, this.finishTime);
          this.timeList = res.data.orderTag;
        }).catch(err => {
          this.$message.error(err.msg);
        })
      },
      getTimeList(beginTime, endTime) {
        let timeList = [];
        for (let i = Number(beginTime.replace(':', '')); i <= Number(endTime.replace(':', '')); i = i % 100 == 30 ? (i + 70) : (i + 30)) {
          timeList.push({
            label: this.getFormatTimeText(String(i)),
            value: this.getFormatTime(String(i))
          });
        }
        return timeList;
      },
      getFormatTimeText(time) {
        let ytime = Number(time.replace(':', ''));
        var c1 = Number(ytime / 100).toFixed(0)
        c1 = c1 < 10 ? ('0' + c1) : (c1 > 23 ? ('次日' + ((c1 - 24) > 9 ? (c1 - 24) : ('0' + (c1 - 24)))) : c1);
        c1 = c1 + ':' + (ytime % 100 ? '30' : '00')
        return c1;
      },
      getFormatTime(time) {
        let ytime = Number(time.replace(':', ''));
        var c1 = Number(ytime / 100).toFixed(0)
        c1 = c1 + ':' + (ytime % 100 ? '30' : '00')
        return c1;
      },
      //收费方式
      getPayType() {
        this.$axios.post('/dic/payTypeCode', {
          "parentId": "1001",
          "dicType": " pay_type_code "
        }).then(res => {
          // console.log('收费方式', res.data)
          this.paywayList = res.data.list;
        }).catch(err => {
          this.$message.error(err.msg);
        })
      },
      paywayChange(data) {
        console.log(data)
        // this.$refs['ruleForm'].validateField('packages');
        for (var i in this.paywayList) {
          if (this.paywayList[i].dicCode == data) {
            this.dataForm.mainPayTypeText = this.paywayList[i].dicName
          }
        }
        this.resetPayway();
        if (data != '03') {
          this.addtables = false;
          this.addpeople = false;
        }
      },
      //重置收费方式
      resetPayway() {
        this.onePrice1 = undefined;
        this.orderPeople1 = undefined;
        this.onePrice2 = undefined;
        this.orderPeople2 = undefined;
        this.bdesks = undefined;
        this.orderall = undefined;
      },
      chooseTime(start, end) {
        if (new Date(this.dataForm.orderDate).getTime() == new Date().getTime()) {
          var myDate = new Date();
          var a = start.split(':');
          var b = [myDate.getHours(), myDate.getSeconds()]
          if (Number(a[0]) < b[0] || Number(a[0]) == b[0] && Number(a[1]) < b[1]) {
            this.$confirm('预定时间段已过, 是否补录?', '刺兔温馨提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.$set(this.dataForm, 'activityBeginTime', start);
              this.$set(this.dataForm, 'activityEndTime', end);
              this.validatorBeginTime();
            }).catch(() => {

            });
          } else {
            this.$set(this.dataForm, 'activityBeginTime', start);
            this.$set(this.dataForm, 'activityEndTime', end);
          }
        } else {
          this.$set(this.dataForm, 'activityBeginTime', start);
          this.$set(this.dataForm, 'activityEndTime', end);
        }

      },
      //更改预定日期
      changeOrderDate(date) {
        //计算提醒日期
        var time = new Date(new Date(date).getTime() - this.orderAlertDaysBefore * 24 * 60 * 60 * 1000)
        var month = time.getMonth() + 1, day = time.getDate();
        if (time.getTime() < new Date().getTime()) {
          this.$set(this.dataForm, 'alertDate', null);
        } else {
          this.$set(this.dataForm, 'alertDate', time.getFullYear() + '-' + (month < 10 ? ('0' + month) : month) + '-' + (day < 10 ? ('0' + day) : day))
        }
        //判断是否是之前的日期补录
        if ((new Date().getTime() > new Date(date).getTime()) && date) {
          this.$confirm('该操作可补录' + date + '的订单, 是否继续?', '刺兔温馨提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.checkedAlert = false;
            this.validatorBeginTime();
          }).catch(() => {
            this.$set(this.dataForm, 'orderDate', null);
          });
        }
        //获取选择日期对应已选的时间段
        if (this.dataForm.orderDate && this.dataForm.houseId) {
          this.timeRepeat(this.dataForm.orderDate, this.dataForm.houseId);
        } else {
          // // this.showtime = false;
          // this.$set(this.dataForm, 'activityBeginTime', '');
          // this.$set(this.dataForm, 'activityEndTime', '');
        }
      },
      //更改场地
      changeHouseInfo(data) {
        console.log(data)
        // console.log(data.houseTypeCode)
        //场地类型
        this.$set(this.dataForm, 'houseTypeCode', data.houseTypeCode || '');
        if (data) {
          if (data.houseTypeCode != '01')
            this.$set(this.dataForm, 'orderTypeId', '');
          if (!this.id) {
            if (data.houseTypeCode == '03') {
              this.downPayment = this.dataForm.downPayment;
              this.$set(this.dataForm, 'downPayment', '0');
            } else {
              this.$set(this.dataForm, 'downPayment', this.downPayment);
            }
          }
        }
        //获取选择日期对应已选的时间段
        if (this.dataForm.orderDate && data.id) {
          this.timeRepeat(this.dataForm.orderDate, data.id);
        } else {

          this.$set(this.dataForm, 'activityBeginTime', '');
          this.$set(this.dataForm, 'activityEndTime', '');
        }

      },
      timeRepeat(orderDate, houseId) {
        this.$axios.post('/order/houseActivityTimes', {
          "houseId": houseId,
          "orderDate": orderDate,
          "storeId": this.$root.getStorage('storeId')
        }).then(res => {
          // console.log('重复时间', res.data)
          //获取当前
          var data = res.data.list;
          for (var i = 0, len = data.length; i < len; i++) {
            if (new Date(this.dataForm.orderDate + ' ' + this.startTime).getTime() == new Date(this.dataForm.orderDate + ' ' + data[i].activityBeginTime).getTime() && new Date(this.dataForm.orderDate + ' ' + this.endTime).getTime() == new Date(this.dataForm.orderDate + ' ' + data[i].activityEndTime).getTime()) {
              data.splice(i, 1);
              break;
            }
          }
          this.selectableRange = data;

          this.$refs['ruleForm'].validateField('activityBeginTime');
          this.$refs['ruleForm'].validateField('activityEndTime');
        }).catch(err => {
          this.$message.error(err.msg);
        })

      },
      //检查起始时间
      validatorBeginTime() {
        this.$set(this.dataForm, 'eatTime', null)
        this.$refs['ruleForm'].validateField('activityBeginTime');
      },
      changeBeginTime(date) {
        // console.log(date)
        this.$set(this.dataForm, 'activityEndTime', null)
        this.$set(this.dataForm, 'eatTime', null)
      },
      //修改套餐
      fixedSetmeal() {
        this.showsetmeal = true;
        this.edittitle = '修改套餐';
      },
      //编辑查看
      editLook() {
        this.showextra = true;
        this.edittitle = '额外合计项目';
      },
      getTotal(data) {
        if (this.edittitle == '修改套餐') {
          var order = JSON.stringify(this.setmealArea).replace(/itemsExTree/g, 'itemsExs');
          order = JSON.parse(order.replace(/itemsFoodTree/g, 'itemsFoods'));
          this.dataForm.orderPackage = order;
          console.log('修改套餐list', order)
        } else {
          var order = JSON.stringify(this.extraArea).replace(/itemsExTree/g, 'itemsExs');
          order = JSON.parse(order.replace(/itemsFoodTree/g, 'itemsFoods'));
          this.dataForm.orderExtra = order;
          this.dataForm.extraRealMoney = data.nowPrice;
          console.log('额外list', order)
        }

      },
      changePackage(data) {
        if (data) {
          this.$set(this.dataForm, 'packageName', data.packageName);
          this.$axios.get('/foodPackage/foodPackageById/' + data.packageTypeCode).then(res => {
            console.log(res)
            let itemsFoodTree = [],
              itemsExTree = [];
            if (res.data) {
              for (var i in res.data.itemsFoodTree) {
                itemsFoodTree.push({
                  id: res.data.itemsFoodTree[i].itemId,
                  foodId: res.data.itemsFoodTree[i].itemId,
                  foodCount: res.data.itemsFoodTree[i].itemCount,
                  foodPrice: res.data.itemsFoodTree[i].itemPrice,
                  foodName: res.data.itemsFoodTree[i].itemName,
                  isChange: res.data.itemsFoodTree[i].isChange || '0',
                  packageId: res.data.itemsFoodTree[i].packageId,
                })
              }
              for (var i in res.data.itemsExTree) {
                itemsExTree.push({
                  id: res.data.itemsExTree[i].itemId,
                  foodId: res.data.itemsFoodTree[i].itemId,
                  itemCount: res.data.itemsExTree[i].itemCount,
                  itemPrice: res.data.itemsExTree[i].itemPrice,
                  itemName: res.data.itemsExTree[i].itemName,
                  isChange: res.data.itemsExTree[i].isChange || '0',
                  packageId: res.data.itemsExTree[i].packageId,
                })
              }

            }
            //
            this.setmealArea = {
              itemsFoodTree: itemsFoodTree,
              itemsExTree: itemsExTree
            }
            this.dataForm.orderPackage = {
              itemsExs: itemsExTree,
              itemsFoods: itemsFoodTree
            }
          }).catch(err => {
            this.$message.error(err.msg);
          })
        } else {
          this.$set(this.dataForm, 'packageName', null)
        }
      },
      //新增，编辑提交
      editSubmit() {
        var data = this.dataForm;
        this.$axios.post('/order/' + (this.id ? 'orderUpdate' : 'orderAdd'), {
          id: this.id,
          "storeId": this.$root.getStorage('storeId'),
          "askId": data.askId,
          "orderDate": data.orderDate,
          "alertDate": data.houseTypeCode != '03' || this.checkedAlert ? data.alertDate : null,
          "phone": data.phone,
          "customName": data.customName,
          "activityBeginTime": data.activityBeginTime,
          "activityEndTime": data.activityEndTime,
          "packageName": data.houseTypeCode == '03' ? null : data.packageName,
          "packageId": data.houseTypeCode == '03' ? null : data.packageId,
          "houseId": data.houseId,
          "mainPayTypeText": data.houseTypeCode == '03' ? null : data.mainPayTypeText,
          "mainPayType": data.houseTypeCode == '03' ? null : data.mainPayType,
          "payTypes": data.houseTypeCode == '03' ? null : data.payTypes,
          "orderState": data.orderState,
          "orderTypeId": data.houseTypeCode == '01' ? data.orderTypeId : '',
          "customFromId": data.customFromId,
          "downPayment": data.downPayment,
          "orderPackage": data.houseTypeCode == '03' ? null : data.orderPackage,
          "orderExtra": data.orderExtra,
          "packageRealMoney": data.packageRealMoney,//套餐实收款
          "packageNeedMoney": data.packageNeedMoney,//套餐应收款
          "extraRealMoney": data.extraRealMoney,
          "eatTime": data.eatTime,
          "orderMoney": data.orderMoney,//订单金额（总计应收款）
          "remark": data.remark
        }).then(res => {
          this.loading = false;
          // let orderDate = data.orderDate;
          this.$emit('refresh', data.orderDate);
          this.resetForm();
          this.$message.success((this.id ? '编辑' : '新增') + '预定单成功！');
        }).catch(err => {
          this.loading = false;
          console.log(1212)
          this.$message.error(err.msg);
        })
      },
      submitForm(formName) {
        console.log(this.dataForm)
        this.$refs['ruleForm'].validate((valid) => {
          console.log(valid)
          if (valid) {
            this.loading = true;
            this.dataForm.payTypes = [];
            if (this.dataForm.mainPayType == '01') {
              this.dataForm.payTypes.push({
                onePrice: this.onePrice1,
                payType: '01',
                orderCount: this.orderPeople1,
                payTypeCode: '01',
              });
            }
            if (this.dataForm.mainPayType == '02') {
              this.dataForm.payTypes.push({
                onePrice: this.onePrice2,
                payType: '02',
                orderCount: this.orderPeople2,
                bakOrderCount: this.bdesks,
                payTypeCode: '02',
              });
            }
            if (this.dataForm.mainPayType == '03') {
              console.log(this.orderPeople1, this.onePrice1)
              if (this.addpeople) {
                this.dataForm.payTypes.push({
                  onePrice: this.onePrice1,
                  payType: '01',
                  orderCount: this.orderPeople1,
                  payTypeCode: '01',
                });
              }
              if (this.addtables) {
                this.dataForm.payTypes.push({
                  onePrice: this.onePrice2,
                  payType: '02',
                  payTypeCode: '02',
                  orderCount: this.orderPeople2,
                  bakOrderCount: this.bdesks
                });
              }
              this.dataForm.payTypes.push({housePrice: this.orderall, payType: '03', payTypeCode: '03'});
            }
            this.editSubmit();
          } else {
            this.$message.error('表单填写有误');
            return false;
          }
        });
      },
      //todo 取消订单
      cancelOrder() {
        console.log(121)
        this.$axios.post('order/cancelByIds/',
          this.id
        ).then(res => {
          this.$message.success('订单取消成功');
          this.$emit('refresh', this.dataForm.orderDate);
          this.resetForm();
        }).catch(err => {
          this.$message.error(err.msg);

        })
      },
      resetForm() {
        console.warn('进来了')
        this.selectableRange = [];
        this.checkedAlert=false;
        //一定要关闭了在清空
        this.$emit('update:visible', false);
        this.$refs.ruleForm.resetFields();
        this.dataForm = this.$options.data().dataForm;

      }
    }
  }
</script>

<style scoped lang="scss">
  .rulefrom {
    padding: 0 30px;
  }

  .alerttext {
    margin-top: -30px;
    padding: 20px 70px;
    color: #666;
    font-size: 12px;
  }

  .books {
    .haschoosetime {
      font-size: 12px;
      color: #ccc;
    }

    .btn1 {
      width: 36px;
      text-align: center;
    }

    .fixmeal {
      .top {
        border-bottom: 1px solid #eee;
        padding-bottom: 5px;
      }

      .row {
        .left {
          border-right: 1px solid #eee;
          height: 260px;
          overflow-y: scroll;
        }

        .right {
          .item {
            height: 200px;
            overflow-y: scroll;
          }

          padding-left: 20px;
        }
      }
    }
  }
</style>
